module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_rowhouse-5f48a7f369d6cdc5071c826150af6c66.svg";